import React, { memo } from 'react';
import styled from 'styled-components';

import Button from '../../../Button';

import { EditField, FieldClose } from '@icons/common';

interface ICallReason {
  className?: string;
  type: string;
  reasons: Array<{ value: string; title: string }>;
  readOnly?: boolean;
  onEditToggle: () => void;
  onDelete: ({ value }: { value: string }) => void;
}

const CallReason = ({
  className = '',
  type,
  reasons,
  readOnly = false,
  onEditToggle,
  onDelete,
}: ICallReason) => (
  <StyledCallReason className={className}>
    <StyledType>
      {type}
      {!readOnly && (
        <StyledEditButton onClick={onEditToggle}>
          <StyledEditIcon />
        </StyledEditButton>
      )}
    </StyledType>
    <StyledList>
      {reasons.map(({ value, title }) => (
        <StyledItem key={value}>
          {title}
          {!readOnly && (
            <StyledDeleteButton onClick={() => onDelete({ value })}>
              <StyledDeleteIcon />
            </StyledDeleteButton>
          )}
        </StyledItem>
      ))}
    </StyledList>
  </StyledCallReason>
);

const StyledCallReason = styled.div`
  color: #4d4d4d;
  font-size: 14px;
`;

const StyledType = styled.b`
  display: flex;
  line-height: 18px;
`;

const StyledList = styled.ul``;

const StyledItem = styled.li`
  display: flex;
  padding-left: 10px;
  position: relative;
  align-items: center;
  justify-content: flex-start;

  &:before {
    top: 8px;
    left: 0;
    width: 3px;
    height: 3px;
    content: '';
    position: absolute;
    border-radius: 100%;
    background-color: #4d4d4d;
  }
`;

const StyledEditButton = styled(Button)`
  width: 15px;
  height: 15px;
  margin-top: 3px;
  margin-left: 6px;
  border: none;
  background: none;
  padding: 0;
  margin: 3px 5px 0;

  &:hover svg path {
    fill: #007aff;
  }
`;

const StyledDeleteButton = styled(Button)`
  width: 12px;
  height: 12px;
  border: none;
  background: none;
  padding: 0;
  overflow: visible;
  margin: 3px 0px 0 5px;

  svg path {
    stroke: #979797;
  }
  &:hover svg path {
    stroke: #007aff;
  }
`;

const StyledEditIcon = styled(EditField)`
  width: 16px;
  height: 15px;
`;

const StyledDeleteIcon = styled(FieldClose)`
  width: 12px;
  height: 12px;
`;

export default memo(CallReason);
